import type { Rule } from "../types";
import { makeFiring, toIsoDate } from "../util";

/**
 * Pantry items past their `expires_on` date. Not evidence-backed (no paper
 * needed for "use before it spoils"); kept here so the rules engine has a
 * coherent story for nutrition operations.
 */
export const pantryExpired: Rule = {
  id: "pantry_expired",
  domain: "health.nutrition",
  topics: ["pantry", "operations"],
  evidence_refs: [],
  title: () => "Pantry items past date",
  evaluate(ctx) {
    const today = toIsoDate(ctx.now);
    const expired = ctx.pantry.filter(
      (p) => p.expires_on != null && p.expires_on < today,
    );
    if (expired.length === 0) return null;
    const list = expired.slice(0, 3).map((p) => p.name).join(", ");
    return makeFiring({
      rule_id: "pantry_expired",
      now: ctx.now,
      tz: ctx.tz,
      severity: "warn",
      message: `${expired.length} pantry item${expired.length === 1 ? "" : "s"} past date: ${list}${expired.length > 3 ? "…" : ""}.`,
      evidence_refs: [],
      factors: [
        {
          name: "expired_count",
          value: expired.length,
          contribution: "discard or use",
          evidence_ref: "",
        },
      ],
      target_surface: "pantry",
    });
  },
};

export const pantryUseToday: Rule = {
  id: "pantry_use_today",
  domain: "health.nutrition",
  topics: ["pantry", "operations"],
  evidence_refs: [],
  title: () => "Pantry items expire today",
  evaluate(ctx) {
    const today = toIsoDate(ctx.now);
    const dueToday = ctx.pantry.filter((p) => p.expires_on === today);
    if (dueToday.length === 0) return null;
    const list = dueToday.slice(0, 3).map((p) => p.name).join(", ");
    return makeFiring({
      rule_id: "pantry_use_today",
      now: ctx.now,
      tz: ctx.tz,
      severity: "neutral",
      message: `Use today: ${list}${dueToday.length > 3 ? "…" : ""}.`,
      evidence_refs: [],
      factors: [
        {
          name: "use_today_count",
          value: dueToday.length,
          contribution: "plan a meal",
          evidence_ref: "",
        },
      ],
      target_surface: "pantry",
    });
  },
};
